import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Container = styled.div`
  padding: 20px 30px 40px;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  font-size: 20px;
  font-weight: bold;

  svg {
    right: 0 !important;
  }
`

export const Description = styled.div`
  font-size: 14px;
  color: ${colors.gray320};
`

export const CompaniesContainer = styled.div`
  margin: 16px -4px -4px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 50vh;
  overflow-y: auto;
`

export const CompanyWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  font-size: 20px;
  border: 2px solid transparent;

  > svg {
    flex-shrink: 0;
    font-size: 28px;
  }

  &:hover {
    border: 2px solid ${colors.purple400};
  }
`

export const CompanyInfo = styled.div`
  min-width: 0;
  font-weight: bold;

  > div:last-child {
    font-size: 14px;
    font-weight: 100;
    margin-top: -6px;
    color: ${colors.gray380};
  }
`
